module.exports = __webpack_public_path__ + "img/thumbnail_Koala_f_albino.89e2439f.png";